// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TabelaBaseLegal Component */
.styles_tabelaContainer__OcyPm {
  margin-top: 0;
}

.styles_tableWrapper__rRMWK {
  border: 1px solid #dfe3eb;
  border-radius: 12px;
  overflow: hidden;
}

.styles_tableHeader__w9xG6 {
  background: #f5f7fb;
}

.styles_tableHeader__w9xG6 .styles_MuiTableCell-head__4Pksc {
  color: #1f2a44;
  font-weight: 600;
  border-bottom: none;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.styles_tableRow__lcg4X:hover {
  background-color: #f9fbff;
}

.styles_tableRow__lcg4X:nth-of-type(even) {
  background-color: #fbfcff;
}

.styles_tableWrapper__rRMWK .styles_MuiTableCell-root__aW8f8 {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.styles_tableWrapper__rRMWK .styles_MuiTableCell-head__4Pksc {
  white-space: nowrap !important;
}

/* Tamanhos mínimos das colunas */
.styles_colContaContabil__juPpl {
  min-width: 180px;
}

.styles_colValorTotal__28\\+NH {
  min-width: 130px;
}

.styles_colPis__kqYQR {
  min-width: 110px;
}

.styles_colCofins__l5qVg {
  min-width: 120px;
}

.styles_colBaseLegalCredito__ItHTN {
  min-width: 300px;
}

.styles_colFundamentacao__kax9y {
  min-width: 220px;
}

.styles_colMedidaJudicial__RSS7i {
  min-width: 140px;
}

.styles_tableWrapper__rRMWK .styles_colBaseLegalCredito__ItHTN,
.styles_tableWrapper__rRMWK .styles_colFundamentacao__kax9y {
  white-space: normal !important;
  word-wrap: break-word;
}

.styles_emptyState__FT9rY {
  padding: 2rem !important;
  color: #64748b;
  font-style: italic;
}

`, "",{"version":3,"sources":["webpack://./src/components/PisCofins/BaseLegal/styles.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* TabelaBaseLegal Component */\n.tabelaContainer {\n  margin-top: 0;\n}\n\n.tableWrapper {\n  border: 1px solid #dfe3eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.tableHeader {\n  background: #f5f7fb;\n}\n\n.tableHeader .MuiTableCell-head {\n  color: #1f2a44;\n  font-weight: 600;\n  border-bottom: none;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n}\n\n.tableRow:hover {\n  background-color: #f9fbff;\n}\n\n.tableRow:nth-of-type(even) {\n  background-color: #fbfcff;\n}\n\n.tableWrapper .MuiTableCell-root {\n  white-space: nowrap !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tableWrapper .MuiTableCell-head {\n  white-space: nowrap !important;\n}\n\n/* Tamanhos mínimos das colunas */\n.colContaContabil {\n  min-width: 180px;\n}\n\n.colValorTotal {\n  min-width: 130px;\n}\n\n.colPis {\n  min-width: 110px;\n}\n\n.colCofins {\n  min-width: 120px;\n}\n\n.colBaseLegalCredito {\n  min-width: 300px;\n}\n\n.colFundamentacao {\n  min-width: 220px;\n}\n\n.colMedidaJudicial {\n  min-width: 140px;\n}\n\n.tableWrapper .colBaseLegalCredito,\n.tableWrapper .colFundamentacao {\n  white-space: normal !important;\n  word-wrap: break-word;\n}\n\n.emptyState {\n  padding: 2rem !important;\n  color: #64748b;\n  font-style: italic;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabelaContainer": `styles_tabelaContainer__OcyPm`,
	"tableWrapper": `styles_tableWrapper__rRMWK`,
	"tableHeader": `styles_tableHeader__w9xG6`,
	"MuiTableCell-head": `styles_MuiTableCell-head__4Pksc`,
	"tableRow": `styles_tableRow__lcg4X`,
	"MuiTableCell-root": `styles_MuiTableCell-root__aW8f8`,
	"colContaContabil": `styles_colContaContabil__juPpl`,
	"colValorTotal": `styles_colValorTotal__28+NH`,
	"colPis": `styles_colPis__kqYQR`,
	"colCofins": `styles_colCofins__l5qVg`,
	"colBaseLegalCredito": `styles_colBaseLegalCredito__ItHTN`,
	"colFundamentacao": `styles_colFundamentacao__kax9y`,
	"colMedidaJudicial": `styles_colMedidaJudicial__RSS7i`,
	"emptyState": `styles_emptyState__FT9rY`
};
export default ___CSS_LOADER_EXPORT___;
